import React from 'react';
import { Menu } from 'lucide-react';
import NotificationBell from './NotificationBell';
import { ViewModeToggleSimple } from './ViewModeToggle';

/**
 * MobileHeader — sticky glass header with HED gradient accent, thick tap
 * targets (min 44×44), safe-area top padding for iOS notches, and truncated
 * page title so long section names never break the layout.
 */
export default function MobileHeader({
  onMenuOpen,
  api,
  portalType = 'admin',
  title = '',
}) {
  const accentBar = {
    admin: 'from-[#1a1a2e] via-fuchsia-500 to-[#FF3D7F]',
    employee: 'from-amber-500 via-orange-500 to-pink-500',
    client: 'from-blue-500 via-indigo-500 to-purple-500',
  }[portalType] || 'from-[#1a1a2e] via-fuchsia-500 to-[#FF3D7F]';

  return (
    <header
      className="sticky top-0 z-40 bg-white/90 dark:bg-[#111111]/90 backdrop-blur-2xl border-b border-neutral-200/70 dark:border-white/[0.06]"
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
      data-testid="mobile-header"
    >
      {/* Thin HED gradient accent bar so mobile has instant brand */}
      <div className={`h-0.5 w-full bg-gradient-to-r ${accentBar}`} />
      <div className="px-4 py-2.5 flex items-center justify-between gap-2">
        <button
          onClick={onMenuOpen}
          className="p-2 -ml-2 rounded-xl hover:bg-neutral-100 active:bg-neutral-200 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
          data-testid="mobile-menu-btn"
          aria-label="Open navigation menu"
        >
          <Menu className="w-6 h-6 text-neutral-700" />
        </button>

        <div className="flex items-center gap-2 min-w-0 flex-1 justify-center">
          <img src="/hed-icon.png" alt="HED" className="w-6 h-6 rounded-lg shrink-0" />
          {title && (
            <span className="font-semibold text-[#1a1a2e] text-sm truncate">
              {title}
            </span>
          )}
        </div>

        <div className="flex items-center gap-1 shrink-0">
          {/* Always-visible dual-UI toggle so users can never get "stuck" in
              mobile view. Same component used in desktop header. */}
          <ViewModeToggleSimple />
          {api && <NotificationBell api={api} portalType={portalType} />}
        </div>
      </div>
    </header>
  );
}
